<template>
  <PCSettingsBlock
    v-if="hasAccessToReturnables"
    :title="t('userConfiguration.commercialisation.title')"
  >
    <PCSettingsBlockItem :title="t('userConfiguration.commercialisation.RequestSignature')">
      <template #right>
        <f7-toggle
          v-model:checked="showSignature"
        />
      </template>
    </PCSettingsBlockItem>
  </PCSettingsBlock>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useSettingRef } from '@erpagroapp/settings';
import { ModuleProcessMappings } from '@erpagroapp/common';

import PCSettingsBlock from './PCSettingsBlock.vue';
import PCSettingsBlockItem from './PCSettingsBlockItem.vue';

const { t } = useI18n();
const { availableProcessIds } = storeToRefs(useAppConfigStore());
const showSignature = useSettingRef('Retornables.MostrarFirma');

const RETURNABLES_PROCESS_ID = ModuleProcessMappings.Commercialisation.Processes.ReturnablesManagement.Id;

const hasAccessToReturnables = computed(() => availableProcessIds.value.includes(RETURNABLES_PROCESS_ID));
</script>
